import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Box, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { Action } from "../../types/toolbar";
import { PROFITABILITY_GROUP_BY_OPTIONS } from "../../consts";
import { serviceActionsSectionStyle } from "../../styles/commonStyles";

const DEFAULT_GROUP_BY = PROFITABILITY_GROUP_BY_OPTIONS[0].value;

export const SettlementsProfitabilityActions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const groupByParam = params.get("group_by") || DEFAULT_GROUP_BY;

  const updateGroupByParam = (value: string) => {
    const nextParams = new URLSearchParams(location.search);

    if (value === DEFAULT_GROUP_BY) {
      nextParams.delete("group_by");
    } else {
      nextParams.set("group_by", value);
    }

    const nextSearch = nextParams.toString();
    navigate({
      pathname: location.pathname,
      search: nextSearch ? `?${nextSearch}` : "",
    });
  };

  const quickFilterActions: Action[] = PROFITABILITY_GROUP_BY_OPTIONS.map((option) => ({
    icon: <FilterAltOutlinedIcon />,
    label: t(option.labelKey),
    onClick: () => updateGroupByParam(option.value),
    color: groupByParam === option.value ? "var(--primaryColor)" : undefined,
  }));

  const quickFilters = (
    <Box component="fieldset" sx={serviceActionsSectionStyle}>
      <Typography
        component="legend"
        variant="subtitle2"
        sx={{
          px: 1,
          mb: 1,
        }}
      >
        {t("Quick filters")}
      </Typography>
      <Toolbar actions={quickFilterActions} noTopPadding showShortcut={false} />
    </Box>
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", minHeight: 0 }}>
      {quickFilters}
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <Toolbar actions={[]} noTopPadding />
      </Box>
    </Box>
  );
};
